import { render, staticRenderFns } from "./LoopsCarousel.vue?vue&type=template&id=79151d38&scoped=true&"
import script from "./LoopsCarousel.vue?vue&type=script&lang=js&"
export * from "./LoopsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./LoopsCarousel.vue?vue&type=style&index=0&id=79151d38&scoped=true&lang=css&"
import style1 from "./LoopsCarousel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79151d38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VImg,VLayout,VRow})
